// src/components/services/WorkProcessSection.js
import React from 'react';

// 1. Importe les composants Swiper et les modules nécessaires
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules'; // Modules Swiper

// 2. Importe les styles de base de Swiper et pour la navigation/pagination
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import './WorkProcessSection.css'; // Ton CSS personnalisé pour cette section

function WorkProcessSection() {
  const processSteps = [
    { id: 1, number: "01", title: "Découverte & Analyse", description: "Compréhension de vos besoins, objectifs et public pour définir les fondations de votre projet.", icon: "🔍" },
    { id: 2, number: "02", title: "Conception & Stratégie", description: "Élaboration des wireframes, maquettes UX/UI et planification technique détaillée pour une solution optimale.", icon: "✍️" },
    { id: 3, number: "03", title: "Développement Agile", description: "Construction de votre solution avec les technologies adaptées et des points réguliers pour assurer l'alignement.", icon: "👨‍💻" },
    { id: 4, number: "04", title: "Tests & Validation", description: "Phase rigoureuse de tests pour garantir la qualité, la performance, la sécurité et la compatibilité.", icon: "✔️" },
    { id: 5, number: "05", title: "Déploiement & Suivi", description: "Mise en ligne de votre projet, suivie d'un accompagnement et d'un support pour sa pérennité.", icon: "🚀" }
  ];

  return (
    <section className="work-process-section">
      <h2 className="section-title">Notre Approche Collaborative</h2> {/* Utilise .section-title de HomePage.css/index.css */}
      
      <Swiper
        modules={[Navigation, Pagination, A11y]} // Enregistre les modules
        spaceBetween={30} // Espace entre les slides
        slidesPerView={1} // Nombre de slides visibles par défaut (mobile)
        navigation // Active les flèches de navigation
        pagination={{ clickable: true }} // Active la pagination cliquable
        grabCursor={true} // Change le curseur en "main qui attrape"
        loop={false} // Mettre true si tu veux une boucle infinie (attention avec peu de slides)
        breakpoints={{
          // Quand la largeur d'écran est >= 640px
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          // Quand la largeur d'écran est >= 1024px
          1024: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        }}
        className="process-steps-swiper" // Classe pour styler le conteneur Swiper si besoin
      >
        {processSteps.map(step => (
          <SwiperSlide key={step.id}>
            {/* La carte de l'étape du processus */}
            <div className={`process-step-card ${step.icon ? 'has-icon' : ''}`}>
              <div className="process-step-number">{step.number}</div>
              {step.icon && <div className="process-step-icon" role="img" aria-label={step.title}>{step.icon}</div>}
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

export default WorkProcessSection;